<button *ngIf="appSettings.showLogout" id="mobile-logout" class="btn btn-stacked hidden-lg hidden-xlg pull-right"
  (click)="logoutFn()">
  <span class="fa fa-lock"></span>
  <span class="mobile-buttons-text">Log Out</span>
</button>
<!-- mobile-logout -->

<a *ngIf="appSettings.showLogin" href="{{loginUrl}}" id="mobile-login" class="btn btn-stacked hidden-lg hidden-xlg pull-right">
  <span class="fa fa fa-sign-in"></span>
  <span class="mobile-buttons-text">Log In</span>
</a>
<!-- mobile-logout -->
